import React, { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Loader2 } from 'lucide-react';

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { handleSessionId } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || '';
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate('/login', { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);
    (async () => {
      try {
        await handleSessionId(sessionId);
        // Clear the fragment and go to discover
        window.history.replaceState(null, '', '/discover');
        navigate('/discover', { replace: true });
      } catch (e) {
        navigate('/login?err=oauth', { replace: true });
      }
    })();
  }, [location, navigate, handleSessionId]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[color:var(--mft-cream)]">
      <div className="flex flex-col items-center gap-3 text-gray-600">
        <Loader2 className="w-8 h-8 animate-spin text-[color:var(--mft-green)]" />
        <p className="text-sm">Signing you in...</p>
      </div>
    </div>
  );
}
